<div
  id="shoppingCartContainer"
  [ngClass]="{
    notInline: !IsInline
  }"
>
  @if (!IsInline) {
    <div class="borderBottom">
      <h4 class="titleText">Shopping Cart</h4>
      <div class="justifiedFlexEnd xCloseButton">
        <button
          data-testid="iconShoppingCartClose"
          class="close xToClose lmargin-auto"
          placement="bottom"
          tt_datatestid="shoppingcart-closebutton-tooltip"
          tt_datapendoid="shoppingcart-closebutton-tooltip"
          tt_arialabel="Shopping cart close button tooltip"
          rw-tooltip="Close cart"
          (click)="hideShoppingCart()"
        >
          x
        </button>
      </div>
    </div>
  }
  @if (IsInline && shoppingCart.items.length > 0) {
    <div class="orderSummaryDivision">
      <br />
      <h4 class="titleText">Your Order Summary</h4>
    </div>
  }
  @if (showGridArea) {
  <div (ngClass)="({ NonInlineComponent: !IsInline })">
      @if (shoppingCart.items.length > 0) {    
    <div class="shoppingCartScrollableArea">
      <wj-flex-grid #flexGrid [allowDragging]="'None'" [selectionMode]="'None'" [allowResizing]="'None'"
        [headersVisibility]="'Column'" [itemsSource]="cartCollectionView" [isReadOnly]="true" width="100%"
        [autoGenerateColumns]="false">
        <wj-flex-grid-column width=".4*" [minWidth]="180" header="Product" binding="Name" [wordWrap]="true">
          <ng-template [cellType]="'Cell'" wjFlexGridCellTemplate let-item="item">
            {{ item.Name }}
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column width=".2*" [minWidth]="80" header="Quantity" binding="Quantity"></wj-flex-grid-column>
        <wj-flex-grid-column width=".2*" [minWidth]="110" header="Item Price" binding="Price">
          <ng-template [cellType]="'Cell'" wjFlexGridCellTemplate let-item="item">
            @if(item.DiscountPercent > 0){
            <div class="preDiscountedPrice">{{ item.Price | currency }}{{ item.IsMonthly ? "/month" : "" }}</div>
            <div>{{ item.Price * ((100 - item.DiscountPercent) / 100) | currency }} ({{ item.DiscountPercent }}% off)
            </div>
            }@else {
            <span>{{ item.Price | currency }}{{ item.IsMonthly ? "/month" : "" }}</span>
            }
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column width=".2*" [minWidth]="110" header="Total Price" binding="NextBillPrice">
          <ng-template [cellType]="'Cell'" wjFlexGridCellTemplate let-item="item">
            @if(item.DiscountPercent > 0){
            <div class="preDiscountedPrice">{{ item.Price | currency }}{{ item.IsMonthly ? "/month" : "" }}</div>
            <div>{{ item.Price * ((100 - item.DiscountPercent) / 100) * item.Quantity | currency }}{{ item.IsMonthly ?
              "/month" : "" }}</div>
            }@else {
            <span>{{ item.Price * item.Quantity | currency }}{{ item.IsMonthly ? "/month" : "" }}</span>
            }
          </ng-template>
        </wj-flex-grid-column>
      </wj-flex-grid>
    </div>
  }
      @if (shoppingCart.items.length === 0) {
        <div>
          <div class="shoppingCartTableEmpty">
            <b data-testid="emptyShoppingCart">No items have been added to your cart.</b>
          </div>
        </div>
      }
      @if (showTotalDue) {
        <div class="totalsLightBlue">
          <span class="pull-left"><b>Total Due Today</b></span>
          <span class="lmargin-auto"
            ><b data-testid="totalDueVaule">{{ shoppingCart.CartTotal | currency }}</b></span
          >
          <span class="taxText">Plus tax where applicable</span>
        </div>
      }
    </div>
  }
  @if (showFutureMonthlyBill) {
    <div class="futureBillDivision dspy-flex">
      <span data-testid="futureMonthlyBill" class="pull-left"
        >Future Monthly Bill (starts {{ PaymentInfo?.NextBillDate | date: 'MM/dd/yyyy' }})</span
      >
      @if (PaymentInfo?.NextBillAmount) {
        <span data-testid="futureMonthlyBillValue" class="lmargin-auto"
          >{{ +PaymentInfo?.NextBillAmount + shoppingCart.CartMonthlyTotal | currency }} /month</span
        >
      }
    </div>
  }
  <div class="promoCodeDivision">
    <h4>Promo Code</h4>
  </div>
  @if (canShowPromoCodeEntry) {
    <app-promo-code
      #promo
      [IdThatPaysForThisOrg]="PaymentInfo?.OrganizationID"
      (PromoEvent)="applyPromo($event)"
    ></app-promo-code>
  }
  @if (showPaymentArea) {
    <div class="shoppingCartPaymentInfo">
      <div class="subTitleText m-b-11 black">Current Payment Method</div>
      @if (showACHInfo) {
        <div class="paymentDetails">
          <div>ACH</div>
          <div>Account Type: {{ PaymentInfo?.PaymentMethods[0]?.ACHTypeName }}</div>
          <div>{{ PaymentInfo?.PaymentMethods[0]?.AccountLast4 }}</div>
        </div>
      }
      @if (showCCInfo) {
        <div class="paymentDetails">
          <div data-testid="PaymentInfo">
            {{ PaymentInfo?.PaymentMethods[0]?.PaymentMethodType }}
            {{ PaymentInfo?.PaymentMethods[0]?.AccountLast4 }}
          </div>
          @if (PaymentInfo?.PaymentMethods[0]?.CCExpireOn) {
            <div data-testid="expDate">
              Expires
              {{ PaymentInfo?.PaymentMethods[0]?.CCExpireOn | date: 'MM/yyyy' }}
            </div>
          }
        </div>
      }
      <div class="m-t-14 paymentDetails">
        <span data-testid="changePaymentTxt"
          >You can change your payment and billing information on the Billing tab.</span
        >
      </div>
    </div>
  }
  @if (!IsInline) {
    <div class="closeButton">
      <div class="m-t-33">
        <app-button id="btnClose" buttonStyle="secondary" label="CLOSE" (clickActionEmitter)="hideShoppingCart()">
        </app-button>
      </div>
    </div>
  }
</div>
